import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_UPLOAD_CREDENTIALS_PIN_CONTENT_TYPE = defineFcm('upload_credentials_pin_content_type')
	.asJson(
		z.object({
			web: z.boolean(),
			ios: z.boolean(),
			android: z.boolean(),
		}),
	)
	.withDefault({ web: false, ios: false, android: false })
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'Upload credentials',
		description: `Per-client switch for pinning a server-controlled Content-Type on upload credentials (the presigned PUT and the POST policy), so an uploader can't store a file under another type such as text/html.
			- web: every client that is not a native app
			- ios / android: the native apps, identified by their x-requested-with header
			Enable web first. Enable ios or android only once every shipped version of that app both sends the signed Content-Type (putContentType) on its upload
			and no longer uploads via the POST path (postUrl / s3formData / s3formDataFields): the typed s3formDataFields has no Content-Type field, so those uploads fail the POST policy with a 403.`,
		template: { web: true, ios: false, android: false },
	});
